let language = {
    "COMBINE_ORDER_SETTINGS_TITLE": "自动拼单规则设置",
    "COMBINE_ORDER_SETTINGS_TIPS": "提示：您应先设置自动付款，然后再设置自动拼单规则。尚未设置自动付款？",
    "COMBINE_ORDER_SETTINGS_BUTTON_SETUP": "去设置自动付款",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_PERIODICALLY": "定期合并您的订单",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_PERIODICALLY_DESCRIPTION": "选择此选项时，您的商店订单将定期发送到QPMN，系统将在此期间自动合并商店订单。",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_DIRECTLY": "直接发送您的订单",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_DIRECTLY_DESCRIPTION": "选择此选项时，您的商店订单将直接发送到QPMN，不会合并您的商店订单。",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_MANUALLY": "手动合并您的订单",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_MANUALLY_DESCRIPTION": "选择此选项时，您需要手动合并商店订单。",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_START_DATE": "开始日期",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_INTERVAL": "间隔",
    "COMBINE_ORDER_SETTINGS_INPUT_LABEL_INTERVAL_DESCRIPTION": "开始日期后的天数在{{timeZone}} UTC。您接下来5次拼单的预计时间。",
    "COMBINE_ORDER_SETTINGS_BUTTON_SAVE": "保存",
    "COMBINE_ORDER_SETTINGS_DATE_LIST_HEADER": "预计时间 (UTC)"
};

export { language }
